import { popperGenerator } from "./createPopper.es.js";
import eventListeners from "./modifiers/eventListeners.es.js";
import popperOffsets from "./modifiers/popperOffsets.es.js";
import computeStyles from "./modifiers/computeStyles.es.js";
import applyStyles from "./modifiers/applyStyles.es.js";
import offset from "./modifiers/offset.es.js";
import flip from "./modifiers/flip.es.js";
import preventOverflow from "./modifiers/preventOverflow.es.js";
import arrow from "./modifiers/arrow.es.js";
import hide from "./modifiers/hide.es.js";
var defaultModifiers = [eventListeners, popperOffsets, computeStyles, applyStyles, offset, flip, preventOverflow, arrow, hide];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
export {
  applyStyles,
  arrow,
  computeStyles,
  createPopper,
  defaultModifiers,
  eventListeners,
  flip,
  hide,
  offset,
  popperGenerator,
  popperOffsets,
  preventOverflow
};
//# sourceMappingURL=popper.es.js.map
